// src/Components/PackageSlider.jsx
import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import './PackageSlider.css';   // ✅ Import custom CSS

import { db } from '../firebase'; 
import { collection, getDocs } from 'firebase/firestore';

function PackageSlider() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const bannersCollectionRef = collection(db, "package_banners"); 
        const querySnapshot = await getDocs(bannersCollectionRef);
        
        const bannerData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setBanners(bannerData);
      } catch (error) {
        console.error("Error fetching banners from Firestore: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  if (loading) {
    return (
      <div className="hero-swiper" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
        <p>Loading Banners...</p>
      </div>
    );
  }

  if (banners.length === 0) {
    return (
      <div className="hero-swiper" style={{ textAlign: 'center', padding: '50px' }}>
        <p>No banners available</p>
      </div>
    );
  }

  return (
    <div className="banner-section" style={{ padding: '20px 0' }}>
      <Swiper
        className="hero-swiper"
        modules={[Autoplay, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        loop={banners.length > 1}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
      >
        {banners.map(banner => (
          <SwiperSlide key={banner.id} className="hero-slide">
            <div className="wrapper-img">
              <img
                src={banner.imageUrl}
                alt={banner.fileName || 'Package Banner'}
                className="banner-img"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default PackageSlider;
